export default __webpack_public_path__ + "static/media/thum8.98e97510.jpg";